import React from "react";
import { Grid, FormControl, InputLabel, Select, MenuItem, TextField, Typography } from "@mui/material";

export default function BookingUpdateForm({ status, notes, handleStatusChange, handleNotesChange, errors = {} }) {
  return (
    <Grid container component="form" noValidate autoComplete="off" spacing={2} sx={{ marginTop: "1px" }}>
      <Grid item xs={12}>
        <FormControl fullWidth size="small">
          <InputLabel id="booking-status-label">Status</InputLabel>
          <Select
            labelId="booking-status-label"
            id="booking-status-id"
            value={status || ""}
            label="Status"
            onChange={handleStatusChange}
            error={Boolean(errors.status)}
          >
            <MenuItem value="PENDING">Pending</MenuItem>
            <MenuItem value="CONFIRMED">Confirmed</MenuItem>
            <MenuItem value="CANCELLED">Cancelled</MenuItem>
            <MenuItem value="COMPLETED">Completed</MenuItem>
          </Select>
        </FormControl>
        {errors.status && (
          <Typography color="error" variant="caption" sx={{ mt: 0.5, ml: 1.5 }}>
            {errors.status}
          </Typography>
        )}
      </Grid>
      <Grid item xs={12}>
        <TextField
          size="small"
          fullWidth
          multiline
          rows={4}
          label="Notes (Optional)"
          value={notes || ""}
          onChange={handleNotesChange}
          error={Boolean(errors.notes)}
          helperText={errors.notes}
          placeholder="Add any additional notes or comments..."
        />
      </Grid>
    </Grid>
  );
}
